export default "__VITE_ASSET__BBPk0tm8__"